import React, { Component } from "react";
import { Link } from "gatsby";

class NavLink extends Component {
  render() {
    if (this.props.url) {
      // the link has a url that contains "http", it must be an absolute path. Create a regular <a> tag
      if (this.props.url.indexOf("http") !== -1) {
        return (
          <a
            href={this.props.url}
            className={this.props.class}
            title={this.props.title}
            // target="_blank"
            rel="noopener noreferrer"
          >
            {this.props.title}
          </a>
        );
      }

      // the link has a url with no "http", it must be a relative path. Create a Gatsby <Link> tag
      return (
        <Link
          to={this.props.url}
          className={this.props.class}
          title={this.props.title}
          activeClassName="uk-active"
          partiallyActive={true}
        >
          {this.props.title}
        </Link>
      );
    }

    // the link has no url, it must be an in-navigation header. Create a <span> tag
    return <span className="uk-nav-header">{this.props.title}</span>;
  }
}

export default NavLink;
